<template>
  <table class="table table-striped table-hover">
    <thead class="fixedHeader">
      <tr>
        <th v-for="name in columns" :key="name" >
          <span v-if="name === 'allCheckboxes'"><checkbox id="checkbox_column" @input="allCheckbox" /></span>
          <span class="table__cursor-pointer" v-else-if="sortable===true && name!==''" @click="sortBy(name)">
            {{name}}
          </span>
          <span v-else>{{name}}</span>
          <!--https://iconmonstr.com/sort/-->
          <span class="table__sort-icon table__cursor-pointer"  v-if="sortable===true && allowSortable(name)" @click="sortBy(name)">
            <svg class="sort-empty hide-icon"
                 :class="{ 'hide' : hasActiveSort(name) }"
                 xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M8 10v4h4l-6 7-6-7h4v-4h-4l6-7 6 7h-4zm16 5h-10v2h10v-2zm0 6h-10v-2h10v2zm0-8h-10v-2h10v2zm0-4h-10v-2h10v2zm0-4h-10v-2h10v2z"/></svg>
            <svg :class="{ 'sort-desc' : true, 'hide' : !hasActiveSort(name, 'desc') }"
                 xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6 21l6-8h-4v-10h-4v10h-4l6 8zm16-12h-8v-2h8v2zm2-6h-10v2h10v-2zm-4 8h-6v2h6v-2zm-2 4h-4v2h4v-2zm-2 4h-2v2h2v-2z"/></svg>
            <svg :class="{ 'sort-asc' : true, 'hide' : !hasActiveSort(name, 'asc') }"
                 xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6 3l-6 8h4v10h4v-10h4l-6-8zm16 6h-8v-2h8v2zm2-6h-10v2h10v-2zm-4 8h-6v2h6v-2zm-2 4h-4v2h4v-2zm-2 4h-2v2h2v-2z"/></svg>
          </span>
        </th>
      </tr>
    </thead>
    <tbody class="scrollContent">
      <tr v-for="item in data" :id="item.id" :key="item.id">
        <template v-for="(name, key) in columns">
          <td v-if="$scopedSlots[key]" :key="key">
              <slot :name="key" :item="item"></slot>
          </td>
          <td v-else :key="key">
            {{item[key]}}
          </td>
        </template>
      </tr>
    </tbody>
  </table>
</template>

<script>
import ButtonCta from '@/components/Button/button'
import Checkbox from '@/components/Form/Checkbox/checkbox'
export default {
  name: 'Table',
  components: {
    ButtonCta,
    Checkbox
  },
  props: {
    type: String,
    columns: Object,
    data: Array,
    editable: Boolean,
    sortable: Boolean,
    triggerModal: {
      type: Function,
      required: false
    },
    activeSortData: Array,
    allowedSortColumns: { type: Array, default: null }
  },
  data: () => ({
    toggleAllCheckboxes: false,
    currentSortBy: {
      sortKey: false,
      sortDirection: ''
    }
  }),
  methods: {
    allCheckbox () {
      this.toggleAllCheckboxes = !this.toggleAllCheckboxes
      this.$emit('toggleCheckboxes', this.toggleAllCheckboxes)
    },
    sortBy (name) {
      if (!this.allowedSortColumns || this.allowedSortColumns.length === 0) {
        var obj = {}
        obj['name'] = name
        this.$emit('onAddSort', obj)
        return false
      }

      const column = this.findAllowedSortColumn(name)
      if (!column) return false

      const sortStr = this.activeSortData.find((value) => value.toLowerCase().indexOf(column.toLowerCase()) === 0)
      const sortArray = sortStr ? sortStr.split(':') : false

      const currentSort = sortArray ? {
        sortKey: sortArray[0],
        sortDirection: sortArray[1]
      }
        : {
          sortKey: false,
          sortDirection: ''
        }

      if (currentSort.sortKey !== column) {
        currentSort.sortKey = column
        currentSort.sortDirection = 'desc'
        this.$emit('dispatchSortEvent', currentSort)
        return false
      }
      if (currentSort.sortDirection === 'desc') {
        currentSort.sortDirection = 'asc'
        this.$emit('dispatchSortEvent', currentSort)
        return false
      }
      if (currentSort.sortDirection === 'asc') {
        currentSort.sortDirection = null
        this.$emit('dispatchSortEvent', currentSort)
        return false
      }
    },
    allowSortable (field) {
      return !!this.findAllowedSortColumn(field)
    },
    findAllowedSortColumn (field) {
      if (!this.allowedSortColumns) return null
      const column = this.allowedSortColumns
        .find((value) => typeof value === 'object'
          ? value.name.toLowerCase() === field.toLowerCase() : value.toLowerCase() === field.toLowerCase())
      return typeof column === 'object' ? column.key : column
    },
    hasActiveSort (field, direction = false) {
      const column = this.findAllowedSortColumn(field)
      if (direction) {
        return !!this.activeSortData.find((value) => value.toLowerCase().indexOf(`${column}:${direction}`.toLowerCase()) === 0)
      }
      return !!this.activeSortData.find((value) => value.toLowerCase().indexOf(column.toLowerCase()) === 0)
    }
  }
}
</script>

<style lang="scss">
    @import "./table";
</style>



// WEBPACK FOOTER //
// src/components/Table/table.vue